export default __webpack_public_path__ + "static/media/rightArrow.5ef1e2f8.svg";